import { useMemo } from 'react';

import { useContestsSubscriptionsState } from './hooks/states';

export default function useDefinitions() {
  const { query: defaultParams } = useContestsSubscriptionsState()

  return useMemo(() => ({
    entityName: 'Subscription',
    entityNamePlural: 'Subscriptions',
    entityNameModule: 'cms',
    basePath: `/cms/post/contests/subscriptions`,
    defaultParams,
    sort: [],
  }), [defaultParams])
}
